import { useTranslation } from '../../../hooks/use-translations';
import styles from './DidYouKnowSection.module.scss';
import React from 'react';
import { CarouselBeta, CarouselSlideBeta, P1, P2 } from '@zooplus/ui-components';
import { range } from '../../../utils';
import { EmblaOptionsType } from 'embla-carousel';
import { EnrichedText } from '../../common/enriched-text/EnrichedText';

export type DidYouKnowSectionProps = {
  sectionNumber: number;
  numberCards: number;
};

export const DidYouKnowSection = (props: DidYouKnowSectionProps) => {
  const { t } = useTranslation();

  const options: EmblaOptionsType = {
    align: 'center',
    breakpoints: {
      '(min-width: 0px)': {
        align: 'start',
        slidesToScroll: 1,
      },
      '(min-width: 544px)': {
        align: 'start',
        slidesToScroll: 2,
      },
    },
    slidesToScroll: 1,
  };

  const getTitle = () => (
    <div className={`${styles.didYouKnowCard} ${styles.didYouKnowTitleCard}`}>
      <P1 bold className={styles.didYouKnowText}>
        {t(`did-you-know.section${props.sectionNumber}.title`)}
      </P1>
    </div>
  );

  const getContent = (contentNumber: number) => (
    <div className={`${styles.didYouKnowCard} ${styles.didYouKnowContentCard}`}>
      <P1 className={styles.didYouKnowContentCardNumber}>{contentNumber}</P1>
      <div className={styles.didYouKnowContentCardDivider} />
      <P2 className={styles.didYouKnowText}>
        <EnrichedText
          textKey={`did-you-know.section${props.sectionNumber}.content${contentNumber}`}
        />
      </P2>
    </div>
  );

  return (
    <section>
      <div className={styles.didYouKnowSectionMobile}>
        <CarouselBeta
          id={`did-you-know-carousel-${props.sectionNumber}`}
          nextButtonAriaLabel="next"
          previousButtonAriaLabel="previous"
          className={styles.didYouKnowSectionCarousel}
          emblaOptions={options}
          gap={'12px'}>
          <CarouselSlideBeta className={styles.didYouKnowElement}>{getTitle()}</CarouselSlideBeta>
          {range(1, props.numberCards).map((cardNumber) => (
            <CarouselSlideBeta className={styles.didYouKnowElement}>
              {getContent(cardNumber)}
            </CarouselSlideBeta>
          ))}
        </CarouselBeta>
      </div>
      <div className={styles.didYouKnowSectionDesktop}>
        {getTitle()}
        <div className={styles.didYouKnowContent}>
          {range(1, props.numberCards).map((cardNumber) => getContent(cardNumber))}
        </div>
      </div>
    </section>
  );
};
